import Footer from "./footer";
import Wallet_modal from "./modal/wallet_modal";
import BidsModal from "./modal/bidsModal";
import BuyModal from "./modal/buyModal";
import BurnModal from "./modal/burnModal";
import { Hero } from "./component";
import React from "react";
import HeaderAuthenticated from "./header/HeaderAuthenticated";
import {useAuth} from "react-oidc-context";

export default function Layout({ children }) {
    const auth = useAuth();

  return (
    <>
      {auth.isAuthenticated && <HeaderAuthenticated />}
      <Wallet_modal />
      <BidsModal />
      <BuyModal />
      <BurnModal />
      {auth.isAuthenticated && <main>{children}</main>}
      {!auth.isAuthenticated && <Hero />}
      <Footer />
    </>
  );
}